import { useEffect, useState } from 'react'
import legalService from '../services/legalService'
import Card from '../components/ui/Card'
import PageShell from '../components/ui/PageShell'
import { formatDate, formatDateTime } from '../utils/date'

function toReadableType(type) {
  if (!type) return 'Legal Document'
  return type.split('_').map((word) => word[0].toUpperCase() + word.slice(1)).join(' ')
}

export default function LegalDocuments() {
  const [documents, setDocuments] = useState([])
  const [acceptances, setAcceptances] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let isMounted = true
    const load = async () => {
      setLoading(true)
      try {
        const [currentDocs, accepted] = await Promise.all([
          legalService.getCurrentDocuments(),
          legalService.getAcceptances(),
        ])
        if (isMounted) {
          setDocuments(Array.isArray(currentDocs) ? currentDocs : [])
          setAcceptances(Array.isArray(accepted) ? accepted : [])
        }
      } catch (_error) {
        if (isMounted) {
          setDocuments([])
          setAcceptances([])
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }
    load()
    return () => {
      isMounted = false
    }
  }, [])

  if (loading) {
    return <div className="text-sm text-muted-foreground">Loading legal documents...</div>
  }

  return (
    <PageShell>
      <div className="max-w-4xl mx-auto space-y-6">
      <Card className="p-6">
        <h1 className="text-xl font-semibold text-foreground mb-4">Legal Documents</h1>
        <div className="space-y-3">
          {documents.map((document) => (
            <div key={document.id} className="rounded-md border border-outline p-3">
              <p className="text-sm font-medium text-foreground">{toReadableType(document.type)}</p>
              <p className="text-xs text-muted-foreground">Version: {document.current?.version || 'n/a'}</p>
              {document.current?.effectiveFrom ? (
                <p className="text-xs text-muted-foreground">
                  Effective: {formatDate(document.current.effectiveFrom)}
                </p>
              ) : null}
              {document.current?.changeSummary ? (
                <p className="text-xs text-muted-foreground mt-1">{document.current.changeSummary}</p>
              ) : null}
            </div>
          ))}
        </div>
      </Card>

      <Card className="p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Your Acceptance History</h2>
        <div className="space-y-2">
          {acceptances.length === 0 ? (
            <p className="text-sm text-muted-foreground">No legal acceptances found.</p>
          ) : (
            acceptances.map((item) => (
              <div key={item.id} className="rounded-md border border-outline p-3">
                <p className="text-sm font-medium text-foreground">{toReadableType(item.documentType)}</p>
                <p className="text-xs text-muted-foreground">Accepted version: {item.version}</p>
                <p className="text-xs text-muted-foreground">
                  Accepted at: {item.acceptedAt ? formatDateTime(item.acceptedAt) : 'n/a'}
                </p>
              </div>
            ))
          )}
        </div>
      </Card>
    </div>
    </PageShell>
  )
}

